import React from 'react';
import './Expertoptimization.css';
import exper from '../../../imgs/expert.webp';


const Expertoptimization = () => {
    return (
        <div className="Material-container">
            <div className='Materialsl'>
                <h2 className="Material-title">As an expert in molding solutions and cost optimization</h2>
                                <p className="Material-date">Disha</p>
                 <p className="Material-text"> will demonstrate the injection molding solutions
                    for cosmetics packaging and daily necessities at the fair, showing 
                    Powerjet to the industry with the new advantages of
                     “Precision, High-speed, High-efficiency, and Automation”.</p>
                <p className="Material-text">Effectively provide customers with a steady stream of competitiveness in their
                     pursuit of cost optimization and profit maximization.</p>
                              <div className="advantpl">
                    <img src={exper} alt="72 Cavity PET Preforms Machine" className="advantpla-image" />
                </div>
                                <p className="Material-text">It adopts special high-mixing screw for PET packaging,
                                     low-temperature barrel design, and increases the ejector force.</p>

             
            </div>
        </div>
    );
};
export default Expertoptimization;
